import type { AppSelector } from "../../types";
import type { Nullable } from "../../utils/nullable";
import type { Path } from "../types/routerTypes";

export const getRedirect: AppSelector<Nullable<Path>> = (state) => state.auth.redirect;
